<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <jm-crumbs/>

          <el-form>
            <div class="basic-title">
              <em>生日礼发放提醒</em>
              <router-link tag="em" class="normal" :to="{ name: 'japanPlanAbroad' }">留学规划书提醒</router-link>
            </div>
            <div class="input-area none-month">
              <div class="box-content">
                <label class="form-tit">客户编号：</label>
                <el-input clearable v-model="searchData.crm_id" class="jm-input175"/>
              </div>
              <div class="box-content">
                <label class="form-tit">电话：</label>
                <el-input clearable v-model="searchData.crm_tel" class="jm-input175"/>
              </div>
              <div class="box-content">
                <label class="form-tit">咨询老师：</label>
                <el-select clearable class="jm-input175" v-model="searchData.crm_sayer">
                  <el-option
                    v-for="(item, key) in ds.advisory_teacher"
                    :key="key"
                    :label="item.truename"
                    :value="item.userid"
                  />
                </el-select>
              </div>
              <div class="box-content" style="width:100%">
                <label class="form-tit">签约日期：</label>
                <el-date-picker
                  v-model="searchData.signing_date"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd">
                </el-date-picker>
              </div>
            </div>
            <div class="jm-primary">
              <el-button type="primary" @click="sendForm">查询</el-button>
            </div>
            <el-tabs v-model="searchData.is_send" type="card" @tab-click="tabChange">
              <el-tab-pane label="未发放" name="0"></el-tab-pane>
              <el-tab-pane label="已发放" name="1"></el-tab-pane>
            </el-tabs>
          </el-form>

          <jm-tableList
            url="/index/jp_plan_remind/planGiftList"
            :refresh.sync="refresh"
            :search-data="searchData"
            class="adminList">
            <el-table-column
              slot="lastColumn"
              label="操作"
              width="140">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.is_send === '0'"
                  size="small"
                  type="success"
                  @click="openDialog(scope)">发放</el-button>
                <span v-else>已发放</span>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
    <!--弹窗-->
    <el-dialog
      title="设置发送时间"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="closeDialog">
      <el-form label-width="100px" >
        <el-form-item label="真实姓名：">
          <el-input v-model="sendData.custom_name" disabled class="jm-input280"></el-input>
        </el-form-item>
        <el-form-item label="发送时间：">
          <el-date-picker
            clearable
            class="jm-input280"
            v-model="sendData.send_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveSend"
                   :disabled="!sendData.send_time"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import { jmDictSelect } from '@/components/tool/index.js';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      ds: {},
      dialogVisible: false,
      searchData: {
        crm_tel: null,
        crm_id: null,
        crm_sayer: null,
        signing_date: null,
        is_send: '0'
      },
      sendData: {
        custom_name: '',
        crm_id: null,
        send_time: null
      },
      refresh: false,
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
    jmDictSelect,
  },
  methods: {
    // 表单提交
    sendForm() {
      this.refresh = true;
    },
    getSearchDs() {
      return new Promise((resolve) => {
        this.$http._get({
          url: '/index/jp_plan_remind/searchDs'
        }).then(({ data }) => {
          resolve(data);
        });
      });
    },
    saveSendGift(postData) {
      return new Promise((resolve) => {
        this.$http._post({
          url: '/index/jp_plan_remind/saveSendGift',
          data: postData
        }).then(({ data }) => {
          resolve(data);
        });
      });
    },
    tabChange() {
      this.searchData.crm_id = '';
      this.searchData.crm_tel = '';
      this.searchData.crm_sayer = '';
      this.searchData.signing_date = '';
      this.sendForm();
    },
    closeDialog() {
      this.sendData.crm_id = null;
      this.sendData.custom_name = '';
      this.sendData.send_time = null;

      this.dialogVisible = false;
    },
    openDialog(scope) {
      this.sendData = {
        plan_type: this.planType,
        crm_id: scope.row.id,
        custom_name: scope.row.custom_name,
        send_time: null
      };
      this.dialogVisible = true;
    },
    saveSend() {
      this.saveSendGift(this.sendData).then(() => {
        this.$message.success('发放成功');
        this.closeDialog();
        this.sendForm();
      });
    }
  },
  mounted() {
    this.getSearchDs().then((res) => {
      this.ds = res;
    });
  },
};
</script>
<style scoped>
.basic-title em.normal {
    border-bottom: none;
}
.basic-title em a {
    color:#333;
}
</style>
<style>
.el-tabs__item {
  height: 36px;
  line-height: 36px;
  font-size: 14px;
}
</style>
